import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { BreadCrumbsComponent } from '../../components/breadcrumbs/breadcrumbsComponent';
import { Form } from '../dictionary/form';
import { groups } from '../../stubs/groups';
import { groupTypes } from './groups-constants';
const groupName = {
    label: `Name`,
    key: `groupName`,
    required: true,
    type: 'text',
    readonly: false
};
const groupTypeOptions = groupTypes;
const groupType = {
    label: 'Type',
    key: 'groupType',
    required: true,
    type: 'select',
    name: 'groupType',
    options: groupTypeOptions,
    labelField: 'label',
    valueField: 'value'
};
const members = {
    label: 'Members',
    key: 'members',
    readonly: true,
    enabled: false,
    name: 'Members',
    type: 'text',
    helpText: 'Create the group first, then you may add members'
};
const GroupInfo = {
    label: `Group Information`,
    fields: [
        groupName,
        groupType
    ]
};
const buttons = [
    {
        buttonType: 'submit',
        buttonText: 'Create'
    },
    {
        buttonType: 'link',
        buttonText: 'cancel'
    }
];
export const AddGroup = (props)=>{
    const { handleCancel, errors, handleSave, tenantId } = props;
    const initialGroup = {
        ...groups.defaultGroup,
        tenantId
    };
    let [addGroup, setAddGroup] = useState(initialGroup);
    const formDefinition = ()=>{
        const formDef = {
            fieldGroups: [
                {
                    ...GroupInfo
                }
            ],
            fields: [
                members
            ],
            buttons
        };
        return formDef;
    };
    const enableForm = ()=>{
        return addGroup.groupName.length !== 0 && addGroup.groupType.length !== 0;
    };
    const handleFormChange = (prop, value)=>{
        let editedGroup = addGroup;
        if (prop === 'groupName') {
            editedGroup.groupName = value;
        }
        if (prop === 'groupType') {
            editedGroup.groupType = value;
        }
        setAddGroup(editedGroup);
    };
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx(BreadCrumbsComponent, {}),
            /*#__PURE__*/ _jsx(Form, {
                title: 'Add Group',
                formDefinition: formDefinition(),
                dataItem: addGroup,
                enable: enableForm,
                errors: errors,
                inline: false,
                onAction: handleCancel,
                onSave: handleSave,
                onPropChange: handleFormChange
            })
        ]
    });
};
